module.exports = __webpack_public_path__ + "static/img/banner4.1d607fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner4.png
// module id = RHBR
// module chunks = 0